import React from 'react';
import { RouteComponentProps } from './helpers/RouteComponentProps';
import { PageContainer } from './layout/Layout';
import { Header1 } from './shared/Headers';
import { Link } from './shared/Link';

type NotFoundComponent = {
  (props: RouteComponentProps): JSX.Element;
};

export const NotFound: NotFoundComponent = () => (
  <PageContainer>
    <Header1>Not Found</Header1>
    <p>Sorry, we couldn't find what you were looking for.</p>
    <p>This page may have been moved or deleted.</p>
    <Link to="/">Return to Home</Link>
  </PageContainer>
);
